export const FlowStepGroup = {
	BackgroundInformation: 'BackgroundInformation',
	Data: 'Data',
	Overview: 'Overview',
} as const

export type FlowStepGroup = (typeof FlowStepGroup)[keyof typeof FlowStepGroup]

export const FlowStepSubGroup = {
	BackgroundInformation: 'BackgroundInformation',
	TaxInformation: 'TaxInformation',
	BankConnect: 'BankConnect',
	DataSharing: 'DataSharing',
	CreationOfBudget: 'CreationOfBudget',
	OverviewOfDebt: 'OverviewOfDebt',
	OverviewOfAssets: 'OverviewOfAssets',
	OverviewOfIncome: 'OverviewOfIncome',
	OverviewOfYourFinances: 'OverviewOfYourFinances',
	CreationOfHistoricalAverages: 'CreationOfHistoricalAverages',
	TaxInformationWithPension: 'TaxInformationWithPension',
	Pension: 'Pension',
	SavingsCapacity: 'SavingsCapacity',
} as const

export type FlowStepSubGroup =
	(typeof FlowStepSubGroup)[keyof typeof FlowStepSubGroup]

export interface FlowStepData {
	group: FlowStepGroup
	subGroup: FlowStepSubGroup
}
